import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import _ from "lodash";
import moment from "moment/moment";

export default class ContactPhone extends Model {
  static entity = "contactPhones";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      zepplinId: this.attr(null),
      contactId: this.attr(null),
      isDefault: this.attr(false),
      number: this.attr(null),
      name: this.attr(null),
      legalDocument: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
      status: this.attr('active')
    };
  }

  static afterCreate(model) {
    const contactPhones = ContactPhone.query().where('contactId', model.contactId).get()
    const hasContactAddressDefault = contactPhones.filter(contactPhone => contactPhone.isDefault)
    if(!hasContactAddressDefault.length)
      ContactPhone.update({
          where: contactPhones[0].id,
          data: { isDefault: true }
      })
  }
}
